module.exports = __webpack_public_path__ + "68694c612f16a49d0625b4ffe39a0f69.jpg";